import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CenterGroup from "../components/CenterGroup";
const CustomCenterGroup = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout >

        {/* Breadcrumb */}
        <Breadcrumb title="Center Group" />

        <CenterGroup />

      </MasterLayout>
    </>
  );
};

export default CustomCenterGroup;
